const url = 'https://mashro3-backend.onrender.com';
// const url = 'http://localhost:3002';

export default url;
